import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { RouterView } from 'vue-router'

import '@sennder/design-system-core/dist/styles/themes/default.css'
import '@sennder/design-system-core'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_unref(RouterView))
  ]))
}
}

})